import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Text } from "./../Text/Text";
import { Icon } from "./../Icon/Icon";

export const TasksDropdown = ({
    options = [],
    changeActiveOptionProp = () => { },
    dropdownOpen = () => { },
    rtl,
    active,
    onHeaderHeightChange,
}) => {
    const wrapperRef = useRef(null);
    const headerRef = useRef(null);
    const dropdownOpenRef = useRef(dropdownOpen);
    const onHeaderHeightChangeRef = useRef(onHeaderHeightChange);

    dropdownOpenRef.current = dropdownOpen;
    onHeaderHeightChangeRef.current = onHeaderHeightChange;

    const [isListOpen, setListOpen] = useState(false);
    const [isActive, setActive] = useState(active ? active : 1);

    const changeActiveOption = (index) => {
        setActive(index);
    };

    const showPreQuestion = (type) => {
        if (type === "increase") {
            if (isActive !== 1) {
                changeActiveOption(isActive - 1);
                changeActiveOptionProp(isActive - 1);
            }
        } else if (options.length !== isActive) {
            changeActiveOption(isActive + 1);
            changeActiveOptionProp(isActive + 1);
        }
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setListOpen(false);
                dropdownOpenRef.current(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setActive(active ? active : 1);
    }, [active]);

    useEffect(() => {
        if (headerRef.current && onHeaderHeightChangeRef.current) {
            onHeaderHeightChangeRef.current(headerRef.current.offsetHeight);
        }
    }, [isActive]);

    return (
        <div className="question-dropdown-container" ref={wrapperRef}>
            <div
                className="dropdown-header"
                onClick={(event) => {
                    if (!event.target.classList.contains("dropdown-toggle-disabled")) {
                        setListOpen(!isListOpen);
                        dropdownOpen(!isListOpen);
                    }
                }}
                ref={headerRef}
            >
                <div className="dropdown-header-left">
                    <div className="dropdown-header-top">
                        <p className="text-small-info text-uppercase">
                            <span className="active-question">{isActive}</span>
                            <span className="text-lowercase">of</span> {options.length} - Tree
                            test{" "}
                            <span className="task-dropdown-subtitle-text purple-text">
                                (
                                {options.length > 0
                                    ? options[isActive - 1].subtitle > 1
                                        ? options[isActive - 1].subtitle + " answers"
                                        : options[isActive - 1].subtitle + " answer"
                                    : ""}
                                )
                            </span>
                        </p>
                    </div>
                    <div className="dropdown-header-bottom">
                        <div className="dropdown-header-selected-question">
                            <Text
                                type="body-text-1"
                                fontWeight="medium-font"
                                cssClasses={rtl ? "arabic-font" : ""}
                            >
                                {options && options.length > 0
                                    ? options[isActive - 1].title
                                    : null}
                            </Text>
                        </div>
                        <div className="dropdown-header-arrow-buttons">
                            <div className="bd-que-slide-arrow">
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        showPreQuestion("increase");
                                    }}
                                    className={`${isActive === 1 ? "disabled-link" : ""
                                        } dropdown-toggle-disabled`}
                                >
                                    <Icon
                                        value="back-arrow"
                                        size="medium"
                                        colorClass={"gray-50-svg dropdown-toggle-disabled"}
                                    />
                                </button>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        showPreQuestion("decrease");
                                    }}
                                    className={`${options.length === isActive ? "disabled-link" : ""
                                        } dropdown-toggle-disabled`}
                                >
                                    <Icon
                                        value="forward-arrow"
                                        size="medium"
                                        colorClass={"gray-50-svg dropdown-toggle-disabled"}
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dropdown-header-right">
                    <div className="dropdown-header-chevron">
                        {isListOpen ? (
                            <Icon value="chevron-up" size="medium" />
                        ) : (
                            <Icon value="chevron" size="medium" />
                        )}
                    </div>
                </div>
            </div>

            <div className="dropdown-header-arrow-buttons none-for-desktop mobile-nav-arrows">
                <div className="bd-que-slide-arrow">
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            showPreQuestion("increase");
                        }}
                        className={`${isActive === 1 ? "disabled-link" : ""
                            } dropdown-toggle-disabled`}
                    >
                        <Icon
                            value="back-arrow"
                            size="medium"
                            colorClass={"gray-50-svg dropdown-toggle-disabled"}
                        />
                    </button>
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            showPreQuestion("decrease");
                        }}
                        className={`${options.length === isActive ? "disabled-link" : ""
                            } dropdown-toggle-disabled`}
                    >
                        <Icon
                            value="forward-arrow"
                            size="medium"
                            colorClass={"gray-50-svg dropdown-toggle-disabled"}
                        />
                    </button>
                </div>
            </div>
            {isListOpen && (
                <div className="dropdown-list-hold-wrap">
                    <div className="dropdown-list-container">
                        {options.map((item, index) => (
                            <div
                                className="dropdown-list-item"
                                key={"option-" + item.title + index}
                                onClick={() => {
                                    setListOpen(false);
                                    dropdownOpen(false);
                                    changeActiveOption(index + 1);
                                    changeActiveOptionProp(index + 1);
                                }}
                            >
                                <div
                                    className={
                                        isActive === index + 1
                                            ? "dropdown-active-question dropdown-question-item"
                                            : "dropdown-question-item"
                                    }
                                >
                                    <Text
                                        type="body-text-1"
                                        fontWeight="medium-font"
                                        cssClasses={rtl ? "arabic-font" : ""}
                                    >
                                        {item.title}
                                    </Text>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

TasksDropdown.propTypes = {
    options: PropTypes.array,
    changeActiveOptionProp: PropTypes.func,
    dropdownOpen: PropTypes.func,
};
